// @flow @jsx h
import { Component, h } from 'preact'

import styles from './index.css'

type Person = {
  navn: string,
  epost: string
}

type PersonGroup = {
  gruppenavn: string,
  personer: Person[]
}

type FooterProps = {
  credits: PersonGroup[],
  published: string,
  facebookUrl: string,
  twitterUrl: string
}

export class Footer extends Component<FooterProps> {
  render () {
    const { credits, published, facebookUrl, twitterUrl } = this.props

    return (
      <div class={styles.footer}>
        <div class={styles.byline_block}>
          <ul class={styles.byline_credit_list}>
            {
              credits.map((group, idx) => {
                return <li key={idx}>
                  <h4>{group.gruppenavn}</h4>
                  <p>
                    {group.personer.map((person, idx) => {
                      const joiners = ['', ' og ', ', ']
                      const joinerId = Math.min(2, Math.max(0, group.personer.length - idx - 1))
                      const joiner = joiners[joinerId]

                      if (person.epost) {
                        return [<a key={idx} href={'mailto:' + person.epost}>{person.navn}</a>, joiner]
                      } else {
                        return person.navn + joiner
                      }
                    })}
                  </p>
                </li>
              })
            }

            <li>
              <p style={{ marginTop: '40px' }}>
                Publisert {published}
              </p>
            </li>
          </ul>
          <nav class={styles.byline_sharebutton_container}>
            <ul>
              <li>
                <a
                  data-share='Article:Facebook' rel='noopener noreferrer'
                  target='_blank' href={facebookUrl} class='nrk-button nrk-button--o'>
                  <span class='nrk-sr'>Del på Facebook</span>
                  <svg width='30' height='30' aria-hidden='true'>
                    <use xlinkHref='#nrk-some-facebook' />
                  </svg>
                </a>
              </li>
              <li>
                <a
                  data-share='Article:Twitter'
                  rel='noopener noreferrer' target='_blank' href={twitterUrl} class='nrk-button nrk-button--o'>
                  <span class='nrk-sr'>Del på Twitter</span>
                  <svg width='30' height='30' aria-hidden='true'>
                    <use xlinkHref='#nrk-some-twitter' />
                  </svg>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    )
  }
}
